/* tslint:disable */
/* eslint-disable */
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IInfotextDisplayModel {
  beschreibung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  id?: null | string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  schluessel?: null | string;
}
export class InfotextDisplayModel extends BaseModel implements IInfotextDisplayModel {
  beschreibung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  id?: null | string;
  name?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  schluessel?: null | string;
}
class BaseInfotextDisplayModelFormGroup extends FormGroup {
  private static _instance: InfotextDisplayModelFormGroup;
  
  public static get Instance(): InfotextDisplayModelFormGroup {
    this._instance = new InfotextDisplayModelFormGroup({
      beschreibung: new FormArray([]),
      id: new FormControl(null),
      name: new FormArray([]),
      schluessel: new FormControl(null),
    });

    return this._instance;
  }
}


export class InfotextDisplayModelFormGroup extends BaseInfotextDisplayModelFormGroup {
  public get Beschreibung(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["beschreibung"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get Name(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["name"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Schluessel(): FormControl {
    return this.controls["schluessel"] as FormControl;
  }
  

}

export module InfotextDisplayModelForm
  {
    export class FormFields
    {
      static _beschreibung: string = "beschreibung";
      static _id: string = "id";
      static _name: string = "name";
      static _schluessel: string = "schluessel";
    }
  }

